import { createFileRoute } from "@tanstack/react-router";
import ClientDistribution from "../../../pages/Admin/ClientDistributionPage/ClientDistributionPage";

export const Route = createFileRoute("/(app)/admin/client-distribution")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ClientDistribution />;
}
